export default __webpack_public_path__ + "static/media/CMECompleted.747a688b.svg";